/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Businesseswillappearonceregistered4Inputs */

const en_businesseswillappearonceregistered4 = /** @type {(inputs: Businesseswillappearonceregistered4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Businesses will appear here once they register`)
};

const de_businesseswillappearonceregistered4 = /** @type {(inputs: Businesseswillappearonceregistered4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unternehmen erscheinen hier, sobald sie sich registrieren`)
};

/**
* | output |
* | --- |
* | "Businesses will appear here once they register" |
*
* @param {Businesseswillappearonceregistered4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const businesseswillappearonceregistered4 = /** @type {((inputs?: Businesseswillappearonceregistered4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Businesseswillappearonceregistered4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_businesseswillappearonceregistered4(inputs)
	return de_businesseswillappearonceregistered4(inputs)
});
export { businesseswillappearonceregistered4 as "businessesWillAppearOnceRegistered" }